/**
 * Created by slava on 02.02.17.
 */

const SuperMultiColorCellView = MultiColorCellView.extend({ 
    ctor: function (cell) {
        this._super(cell);
        this.setScale(1.2);
    },

    createAnimation: function () {
        cleverapps.effects.fire("match3.cell.combo.create");

        const blast = new cleverapps.Spine(bundles.game.jsons.blast_spine_json);
        blast.setLocalZOrder(100);
        blast.setPosition(this.width / 2, this.height / 2);
        this.addChild(blast);

        blast.setAnimation(0, "animation", false);
        blast.setCompleteListenerRemove();
    }
});